import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'grow-angular/guards';
import { GuestGuard } from './guards/guest.guard';
import { LoginFormComponent } from './pages/login-form/login-form.component';

//import { LayoutModule } from './pages-frontend/layout/layout.module';
//import { LayoutComponent } from './pages-frontend/layout/layout.component';
//import { DashboardComponent } from './pages-frontend/dashboard/dashboard.component';

const routes: Routes = [
  {
    path: 'app',
    pathMatch: 'full',
    redirectTo: 'error-page',
  },
  /*{
    path: 'v2',
    loadChildren: () => import('./pages-frontend/layout/layout.module').then((m) => m.LayoutModule),
    canActivate: [AuthGuard],
  },
 {
    path: 'dashboard',
    pathMatch: 'full',
    redirectTo: 'v2/dashboard',
  },
  */
  {
    path: '',
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'login-form',
    component: LoginFormComponent,
  },
  {
    path: 'registration',
    loadChildren: () => import('./pages/registration/registration.module').then((m) => m.RegistrationModule),
    canActivate: [GuestGuard],
  },
  {
    path: 'error-page',
    loadChildren: () => import('./pages/error-page/error-page.module').then((m) => m.ErrorPageModule),
  },
  {
    path: '**',
    redirectTo: 'error-page',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  //imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
